import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';

import scrollIntoView from 'scroll-into-view';

import classNames from 'classnames/bind';
import style from './ScrollToTop.scss';
const ctx = classNames.bind(style);

import ReactScrollUp from 'react-scroll-up';

class ScrollToTop extends PureComponent {
  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    return (
      <div className={ctx('scroll-to-top')}>
        <ReactScrollUp showUnder={160}>
          <div className={ctx('arrow-container')}>
            <img
              src={'images/tinyArrowIcon.svg'}
              className={ctx('arrow-svg')}
            />
          </div>
        </ReactScrollUp>
      </div>
    );
  }
}

export default ScrollToTop;
